import 'css-chunksrc/feature/remoteClockout/RemoteClockoutModal.module.scss';export default {
  "content": "RemoteClockoutModal_content"
};